import { Doughnut } from "vue-chartjs";
import Chart from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import "chartjs-adapter-moment";

export default {
  extends: Doughnut,
  props: {
    dataset: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        cutoutPercentage: 65,
        labelFontFamily: "Montserrat",
        labelFontStyle: "bold",
        tooltips: {
          bodyFontFamily: "Montserrat",
          bodyFontStyle: "bold"
        }
      }
    };
  },
  watch: {
    dataset() {
      this.createChart();
    }
  },
  beforeCreate() {
    Chart.plugins.unregister(ChartDataLabels);
  },
  mounted() {
    this.createChart();
  },
  methods: {
    createChart() {
      this.renderChart(
        {
          labels: this.dataset.map(({ name }) => name),
          datasets: [
            {
              data: this.dataset.map(({ value }) => value),
              backgroundColor: this.dataset.map(({ color }) => color),
              borderWidth: 5
            }
          ]
        },
        this.options
      );
    }
  }
};
